import { useMutation } from '@connectrpc/connect-query'
import { createBiddingSpotApprovalRequest } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { invalidateSpotApprovalRequestQueries } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'
import { invalidateSpotFeePreviewsOnRejection } from '~/pages/SpotBidding/hooks/spotFeePreviewInvalidation'

/**
 * スポット入札 承認依頼 新規作成 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。 手数料の理由で拒否された時は
 * 開いたままのモーダルが突き合わせているプレビューと設定を取り直す。
 */
export function useCreateBiddingSpotApprovalRequest(): InvalidatingMutationResultFor<
  typeof createBiddingSpotApprovalRequest
> {
  const queryClient = useQueryClient()
  return useWorkflowCaseScopedMutation(
    useMutation(createBiddingSpotApprovalRequest, {
      onSuccess: () => invalidateSpotApprovalRequestQueries(queryClient),
      onError: (err) => invalidateSpotFeePreviewsOnRejection(queryClient, err),
    }),
  )
}
